import { getBrandInfo, useAtomData } from '@lighthouse/shared'
import { pick } from 'rambda'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'

import { appAtom } from '@/atoms/application/state'

import { AppWebsiteTabs } from '../constant'
import SettingTabs from '../SettingTabs'
import { ModuleType } from '../type'

interface SettingDrawerProps {}

const Container = styled.div`
    flex: 0 0 560px;
    height: 100%;
`

const SettingDrawer: React.FC<SettingDrawerProps> = () => {
    const { type: appType, id: appId = '' } =
        useAtomData(
            appAtom,
            useCallback(state => state && pick(['type', 'id'], state), [])
        ) ?? {}

    const options = useMemo(() => {
        return AppWebsiteTabs.filter(({ value }) => {
            const isConfigDomain = getBrandInfo().app.isFilings
            const isConfigAdverting = getBrandInfo().app.isAdverting
            if (value === ModuleType.domain) {
                return isConfigDomain
            }
            if (value === ModuleType.advertising) {
                return isConfigAdverting
            }
            return true
        })
    }, [])
    const [mode, setMode] = useState(options[0].value)
    const location = useLocation()

    useEffect(() => {
        if (location.state?.tab in ModuleType) {
            setMode(location.state?.tab)
        }
    }, [location.state?.tab])

    return (
        <Container>
            <SettingTabs key={appId} appId={appId} currentTab={mode} options={options} onChange={setMode} />
        </Container>
    )
}

export default SettingDrawer
